import moment from "moment"

export interface CreatedEventScheduleArgs {
  id: number
  starts_at: string
  ends_at: string
  entry_deadline: string
  schedule_note: string
  entry_deadline_note: string
  capacity: number
  place: string
  address: string
  number_of_applications: number
  created_at: string
}

export class EventSchedule {
  id: number
  startsOn: string | null
  endsOn: string | null
  entryDeadline: string | null
  scheduleNote: string | null
  entryDeadlineNote: string | null
  capacity: number
  place: string
  address: string
  numberOfApplications: number
  createdAt: string
  beforeEntryDeadline: boolean

  constructor(args: CreatedEventScheduleArgs) {
    this.id = args.id
    this.startsOn = args.starts_at && moment(args.starts_at).format("YYYY/MM/DD(ddd) HH:mm")
    // 開始日と日付が一緒の場合は時間のみを表示
    this.endsOn =
      args.starts_at &&
      args.ends_at &&
      (moment(args.starts_at).format("MM/DD") === moment(args.ends_at).format("MM/DD")
        ? moment(args.ends_at).format("HH:mm")
        : moment(args.ends_at).format("YYYY/MM/DD(ddd) HH:mm"))
    this.entryDeadline = args.entry_deadline && moment(args.entry_deadline).format("YYYY/MM/DD(ddd) HH:mm")
    this.scheduleNote = args.schedule_note
    this.entryDeadlineNote = args.entry_deadline_note
    this.capacity = args.capacity
    this.place = args.place
    this.address = args.address
    this.numberOfApplications = args.number_of_applications
    this.createdAt = args.created_at
    this.beforeEntryDeadline = moment(args.entry_deadline) > moment()
  }
}
